import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import adminComplaintService from '../api/adminComplaintService';

const KEYS = {
    all: ['complaints'],
    detail: (id) => ['complaint', id]
};

export const useComplaints = () => {
    return useQuery({
        queryKey: KEYS.all,
        queryFn: () => adminComplaintService.getAll().then((res) => res.data),
        staleTime: 5 * 60 * 1000
    });
};

export const useComplaint = (id) => {
    return useQuery({
        queryKey: KEYS.detail(id),
        queryFn: () => adminComplaintService.getSingle(id).then((res) => res.data),
        enabled: !!id,
        staleTime: 5 * 60 * 1000
    });
};

export const useResolveComplaint = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, status }) => adminComplaintService.resolve(id, status),
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries({ queryKey: KEYS.all });
            queryClient.invalidateQueries({ queryKey: KEYS.detail(id) });
        }
    });
};

export const useNotifyVendorComplaint = () => {
    return useMutation({
        mutationFn: ({ id, message }) => adminComplaintService.notifyVendor(id, message)
    });
};
